import React from 'react';

import { ShareSlideover } from 'src/common/components/share/slide-over';
import { JourneyTemplateSlideover } from 'src/dashboard/components/slide-over/journey-template.slideover';
import { useJourneys } from 'src/store/journeys';
import CreateJourneySlideover from './create-journey.slideover';
import { ChangeOwnershipSlideover } from './change-ownership.slideover';

const DashboardSlideOvers = () => {
  const { updateJourney } = useJourneys();

  return (
    <>
      <CreateJourneySlideover />
      <JourneyTemplateSlideover />
      <ChangeOwnershipSlideover onUpdateJourney={updateJourney} />
      <ShareSlideover onUpdateJourney={updateJourney} />
    </>
  );
};

export default DashboardSlideOvers;
